export default {
  title: '舜天律师事务所',
  themeColor: '#e4601d',
  clientSecret: 'ls_cms_secret',
  apiPrefix: '/cms'
}
